export default "__VITE_ASSET__DlFNX_0F__"